module.exports = __webpack_public_path__ + "img/app@2x.b0bc819a.png";